import { css, cx } from 'emotion';
import { headingSmallLight, lightGrey, textBlock } from 'inside-out/global-styles';

const padding = 24;

export const wrapperLinkStyle = css({
	textDecoration: 'none',
	display: 'block',
});

export const wrapperStyle = css({
	position: 'relative',
	textDecoration: 'none',
	border: `1px solid ${lightGrey}`,
	borderRadius: '6px',
	backgroundColor: '#fff',
	boxSizing: 'border-box',
	padding: `${padding}px`,
	zIndex: '1',
	height: '100%',
	'& > img': {
		display: 'block',
		marginBottom: '18px',
	},
});

export const titleStyle = cx(
	headingSmallLight,
	css({
		marginBottom: '11px',
	})
);

export const bodyStyle = cx(
	textBlock,
	css({
		marginTop: 0,
		marginBottom: '10px',
	})
);

export const metaDateStyle = css({
	fontSize: '12px',
	lineHeight: '18px',
	margin: 0,
	color: '#8A8B8C',
});



// WEBPACK FOOTER //
// ./src/components/shared/cards/policyCard/styles.js